import UploadServer from "../../api/UploadServer";

export default async function urlFileUploader(type='',  url='', folder_id=null){
    if(type === ""){
        return null;
    }

    if (url) {
        let response = await UploadServer({
            params: {
                'file_url': url,
                'file_type': type,
                ...(folder_id && {
                    'folder_id': folder_id
                })
            },
            endpoint: '/upload_file_from_url'
        });
        if (response.success) {
            if(response?.data?.file_id){
               return `/get_file?file_id=${response?.data?.file_id}`
            }
            else{
                return null;
            }
        } else {
            if (response.error === "Duplicates in user_id"){
                return null;
            } else{
                return null;
            }
        }
    } else {
        return null;
    }     
    }